var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8951 34.5753H31.4475M20.516 3.34078L5.63531 14.9147C4.6406 15.6883 4.14324 16.0752 3.78493 16.5596C3.46754 16.9888 3.2311 17.4722 3.08722 17.9862C2.9248 18.5664 2.9248 19.1965 2.9248 20.4567V36.3305C2.9248 38.7881 2.9248 40.0169 3.40308 40.9555C3.82378 41.7812 4.49508 42.4525 5.32075 42.8732C6.25942 43.3515 7.4882 43.3515 9.94577 43.3515H35.3968C37.8543 43.3515 39.0831 43.3515 40.0218 42.8732C40.8475 42.4525 41.5188 41.7812 41.9395 40.9555C42.4177 40.0169 42.4177 38.7881 42.4177 36.3305V20.4567C42.4177 19.1965 42.4177 18.5664 42.2553 17.9862C42.1114 17.4722 41.875 16.9888 41.5576 16.5596C41.1993 16.0752 40.7019 15.6883 39.7072 14.9147L24.8265 3.34078C24.0557 2.74125 23.6703 2.44148 23.2447 2.32625C22.8692 2.22458 22.4734 2.22458 22.0979 2.32625C21.6723 2.44148 21.2869 2.74125 20.516 3.34078Z",
    stroke: "white",
    strokeWidth: 4.3881,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c0fafda2005767a77ff0373eb2dbdb28.svg";
export { ForwardRef as ReactComponent };